/* globals elkitorg_config */
import CurrencyUtil from 'common/util/CurrencyUtil';

export default () => Component(function ($context) {
	return $context.select('.credit-info');
}, function ($creditInfo, self) {
	$.extend(self, {
		initEventListeners: function () {
			$creditInfo.on('click', '.credit-info__variant', function () {
				self.changeTerm($(this))
			});

			$creditInfo.on('click', '.credit-info__link', function (e) {
				e.preventDefault();
				Cookies.set('isCredit', true);
				const $add2cart = $('.product__add-to-cart .js-add2cart');

				if ($add2cart.length > 0) {
					$add2cart.trigger('click');
					return false;
				}
				window.location.href = this.href;
			});

			$(document).on('cart_item_change_quantity', function (e, quantity) {
				const $productPrice = $creditInfo.find('.credit-info__price');
				$productPrice.data('quantity', quantity);
				self.recalcPrice();
			});

			$(document).on('cart_item_deleted', function () {
				const $productPrice = $creditInfo.find('.credit-info__price');
				$productPrice.data('quantity', 1);
				self.recalcPrice();
			});
		},
		changeTerm: function ($newVariant) {
			const $term = $creditInfo.find('.credit-info__term');
			$term.data('value', $newVariant.data('value'));
			$term.text($newVariant.text());

			self.recalcPrice();
		},
		getQuantity: function() {

		},
		recalcPrice: function () {
			const $productPrice = $creditInfo.find('.credit-info__price');
			const $term = $creditInfo.find('.credit-info__term');
			const productPrice = $productPrice.data('price');
			const quantity = $productPrice.data('quantity');
			const term = $term.data('value');
			const currency_info = elkitorg_config.currency_info[elkitorg_config.currency];
			const fullPrice = productPrice * quantity;

			self.toggleBlock(fullPrice);

			const creditPrice = CurrencyUtil.format(Math.ceil(fullPrice / term), currency_info, false);

			$productPrice.html(creditPrice)
		},
		toggleBlock: function (fullPrice) {
			$creditInfo.toggleClass('credit-info--hide', fullPrice < 3000);
		}
	});

	self.initEventListeners();
})
